module.exports = __webpack_public_path__ + "static/media/activity_type_sociaal_inverted.21ef6270.svg";